/* simple loading reducer */
export const LOADING = "LOADING";
export const MODAL_OPEN = "MODAL_OPEN";
export const SELECTED_LANGUAGE = "SELECTED_LANGUAGE";
export const DOCUMENT_UPLOADED = "DOCUMENT_UPLOADED";

const initialState = {
  loading: false,
  modalDetails: {},
  selectedLanguage: "en",
  documentUploaded: false,
};

const loadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADING:
      return { ...state, loading: action.payload };
    case MODAL_OPEN:
      return {
        ...state,
        modalDetails: action.payload,
      };
    case SELECTED_LANGUAGE:
      return {
        ...state,
        selectedLanguage: action.payload,
      };
    case DOCUMENT_UPLOADED:
      return { ...state, documentUploaded: action.payload };
    default:
      return state;
  }
};

export default loadingReducer;

export const setLoading = (flag) => ({ type: LOADING, payload: flag });

export const modalOpenMedical = (data) => ({
  type: MODAL_OPEN,
  payload: data,
});

export const setLanguage = (data) => ({
  type: SELECTED_LANGUAGE,
  payload: data,
});

export const documentUpload = (data) => ({
  type: DOCUMENT_UPLOADED,
  payload: data,
});
